import ThemeOption from "@/ts/base/Interfaces/ThemeOption";

declare var TheeAdmin: ThemeOption;

class WpLogin {

	protected options!: ThemeOption;

	protected loginEl!: HTMLElement;
	protected loginHolderEl!: HTMLElement;

	constructor() {

		if (typeof TheeAdmin !== undefined) {
			this.options = TheeAdmin;

			document.addEventListener("DOMContentLoaded", this.init.bind(this));
		}

	}

	init(): void {
		this.loginEl = <HTMLElement>document.getElementById("login");
		this.loginHolderEl = <HTMLElement>document.createElement("div");

		if (this.loginEl instanceof HTMLElement && this.loginHolderEl instanceof HTMLElement) {
			this.addFontAwesomeScriptToHead();
			this.replaceLogo();
			this.restructureDOM();

			window.addEventListener("resize", e => {
				this.resize();
			});

			this.resize();
		}
	}

	addFontAwesomeScriptToHead(): void {
		const script = document.createElement("script");
		script.src = "https://kit.fontawesome.com/3ee51ec6ad.js";
		script.crossOrigin = "anomymous";

		document.head.append(script);
	}

	restructureDOM(): void {
		const loginAreaEl = document.createElement("div");
		const supportHolderEl = document.createElement("div");
		const forgotPwdEl = this.loginEl?.querySelector(".forgetmenot");
		const goBackEl = this.loginEl?.querySelector("#nav");
		const rowEl = document.createElement("div");
		const scrollForSupportEl = document.createElement("a");

		supportHolderEl.classList.add("support-holder", "col-xl-4", "col-lg-5", "col-12",);
		loginAreaEl.classList.add("login-area", "row", "no-gutters");
		rowEl.classList.add("remember-back");

		scrollForSupportEl.classList.add("scroll-down");
		scrollForSupportEl.href = "#login-support";
		scrollForSupportEl.innerHTML = this.getScrollForSupportHtml();

		this.loginHolderEl.classList.add("login-holder", "col-xl-8", "col-lg-7", "col-12");
		this.loginEl.querySelector(".privacy-policy-page-link")?.remove();
		this.loginEl.after(this.loginHolderEl);

		this.loginHolderEl.append(this.loginEl);
		this.loginHolderEl.after(loginAreaEl);
		loginAreaEl.append(this.loginHolderEl);

		supportHolderEl.innerHTML = this.getSupportHolderHtml();
		this.loginHolderEl.after(supportHolderEl);

		if (goBackEl instanceof HTMLElement) {
			goBackEl.after(rowEl);
			if (forgotPwdEl) {
				rowEl.append(forgotPwdEl);
			}
			rowEl.append(goBackEl);
		}


		rowEl.after(scrollForSupportEl);

		scrollForSupportEl.addEventListener("click", (e) => {
			e.preventDefault();
			window.scrollTo({
				top: document.getElementById("login-support")?.offsetTop,
				behavior: "smooth"
			});
		});
	}

	replaceLogo() {
		const h1 = this.loginEl.querySelector("h1");
		if (h1 instanceof HTMLElement) {
			const logo = document.createElement("img");
			const figure = document.createElement("figure");

			figure.classList.add("logo");
			logo.src = <string>this.options.url.logo.landscape;
			logo.alt = "TheeDigital Logo";
			logo.width = <number>this.options.size.logo.landscape.width;
			logo.height = <number>this.options.size.logo.landscape.height;

			figure.append(logo);

			h1.replaceWith(figure);
		}
	}

	resize() {
		let hw = window.innerHeight;
		this.loginHolderEl.style.height = hw + "px";
	}

	getSupportHolderHtml() {
		return `
        <div id="login-support">
                <div class="thee-logo-holder">
                    <a href="https://theedigital.com"
                        class="thee-logo" target="_blank"><img src="${this.options.url.tpl}/dist/img/theedigital-logo.png" alt="TheeDigital"/></a>
                    <div class="logo-under">
                        <h4>Request Website Support!</h4>
                    </div>
                </div>
                <div class="contact-methods">
                    <div class="contact-method phone">
                        <div class="icon-holder"><i class="fa fa-phone"></i></div>
                        <div class="information">
                            <div class="line-1">Sales: (919) 341-8901</div>
                            <div class="line-2"><a href="https://theedigital.com/contact" target="_blank">TheeDigital.com/contact</a></div>
                        </div>
                    </div>
                    <div class="contact-method email">
                        <div class="icon-holder"><i class="fa fa-envelope"></i></div>
                        <div class="information">
                            <div class="line-1">Support: (919) 322-4750</div>
                            <div class="line-2"><a href="https://theedigital.com/support" target="_blank">TheeDigital.com/support</a></div>
                        </div>
                    </div>
                    <div class="contact-method training">
                        <div class="icon-holder"><i class="fa fa-globe"></i></div>
                        <div class="information">
                            <div class="line-1">Free WordPress and SEO Training</div>
                            <div class="line-2"><a href="https://www.theedigital.com/about/events" target="_blank">TheeDigital.com/training</a></div>
                        </div>
                    </div>
                    <div class="contact-method location">
                        <div class="icon-holder"><i class="fa fa-map-marker"></i></div>
                        <div class="information">
                            <div class="line-1">Office</div>
                            <div class="line-2"><a href="https://maps.app.goo.gl/5rPXbfhdxpg1Pd7S6" target="_blank">4205 Wake Forest Road, Suite 100,<br>Raleigh, NC 27609</a></div>
                        </div>
                    </div>
                </div>
            </div>
        `;
	}

	getScrollForSupportHtml() {
		return `
            <p>Scroll down for Support!</p>
            <img src="${this.options.url.tpl}/dist/img/scroll-down.png" alt="scroll down for support" />
        `;
	}


}

export default WpLogin;
